import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const SpeechSynthesisConfigContext = createContext({
  enabled: true,
  gender: "female",
  karaoke: true,
  languages: ["Danish"],
  latexPrinter: "mathematical",
  speed: 3
});
function useSpeechSynthesisConfig() {
  return useContext(SpeechSynthesisConfigContext);
}
function SpeechConfigProvider(props) {
  return /* @__PURE__ */ jsx(SpeechSynthesisConfigContext.Provider, { value: props.config, children: props.children });
}

export { SpeechConfigProvider, useSpeechSynthesisConfig };
//# sourceMappingURL=context.config.js.map
